import { Box } from '@mui/material';
import { useMemo } from 'react';
import './ChatWindow.css';
import InitialMessage from './InitialMessage';
import BlocksMessage from './copilot-component/BlocksMessage';
import PipelineMessage from './copilot-component/PipelineMessage';
import ChatBubble from './copilot-component/ChatBubble';
import LogsTerminal from './copilot-component/LogsTerminal';
import TableMessage from './copilot-component/TableMessage';
import { JsonViewer } from './copilot-component/JsonViewer';

function ChatWindow({ data, handleAddNode, handleAddPipeline, chatHistoryEndRef, setUserMessage, sendUserMessage }) {
  // Group consecutive logs before rendering
  const groupedData = useMemo(() => {
    const result = [];
    let logBuffer = [];

    for (let i = 0; i < data.length; i++) {
      const chat = data[i];

      if (chat.type.toLowerCase() === 'info') {
        logBuffer.push(chat.content);
        const next = data[i + 1];
        if (!next || next.type.toLowerCase() !== 'info') {
          result.push({
            type: 'info',
            sender: chat.sender,
            content: [...logBuffer],
            timestamp: chat.timestamp,
          });
          logBuffer = [];
        }
      } else {
        result.push(chat);
      }
    }

    return result;
  }, [data]);

  return (
    <Box className="chat-window">
      {groupedData.length === 0 ? (
        <InitialMessage setUserMessage={setUserMessage} sendUserMessage={sendUserMessage} />
      ) : (
        groupedData.map((chat, index) => {
          if (chat.type.toLowerCase() === 'text') {
            return <ChatBubble key={index} sender={chat.sender} message={chat.content} />;
          }

          if (chat.type.toLowerCase() === 'blocks') {
            return <BlocksMessage key={index} blocks={chat.content} handleAddNode={handleAddNode} />;
          }

          if (chat.type.toLowerCase() === 'pipeline') {
            return <PipelineMessage key={index} pipeline={chat.content} handleAddPipeline={handleAddPipeline} />;
          }

          if (chat.type.toLowerCase() === 'info') {
            return <LogsTerminal key={index} logs={chat.content} />;
          }

          if (chat.type.toLowerCase() === 'table') {
            return <TableMessage key={index} tableData={chat.content} type={chat.type} />;
          }
          if (chat.type.toLowerCase() === 'plan') {
            return <JsonViewer key={index} content={chat.content} type={chat.type} />;
          }
          <div ref={chatHistoryEndRef} />;
          return null;
        })
      )}
      <div ref={chatHistoryEndRef} />
    </Box>
  );
}

export default ChatWindow;
